import {DISPLAY_TYPES} from 'cl-form/FormSections/consts';
import ListerCategorySelector from './ListerCategorySelector';
import ListerCustomError from './ListerCustomError';
import ListerMultiSelect from './ListerMultiSelect';
import ListerPhotosPicker from './ListerPhotosPicker';
import ListerPhotosPickerGroup from './ListerPhotosPickerGroup';
import ListerRadioButtons from './ListerRadioButtons';
import ListerSingleSelect from './ListerSingleSelect';
import ListerTable from './ListerTable';
import ListerTemplateSelector from './ListerTemplateSelector';
import ListerTextEditor from './ListerTextEditor';
import ListerTextField from './ListerTextField';
import ListerToggle from './ListerToggle';

export default {
  [DISPLAY_TYPES.FREE_TEXT]: ListerTextField,
  [DISPLAY_TYPES.TOGGLE]: ListerToggle,
  [DISPLAY_TYPES.SINGLE_SELECT]: ListerSingleSelect,
  [DISPLAY_TYPES.RADIO_BUTTONS]: ListerRadioButtons,
  [DISPLAY_TYPES.TEXT_IN_EDITOR]: ListerTextEditor,
  [DISPLAY_TYPES.MULTI_SELECT]: ListerMultiSelect,
  [DISPLAY_TYPES.CATEGORY_SELECTOR]: ListerCategorySelector,
  [DISPLAY_TYPES.TEMPLATE_SELECTOR]: ListerTemplateSelector,
  [DISPLAY_TYPES.CUSTOM_ERROR]: ListerCustomError,
  [DISPLAY_TYPES.PHOTOS_PICKER]: ListerPhotosPicker,
  [DISPLAY_TYPES.PHOTOS_PICKER_GROUP]: ListerPhotosPickerGroup,
  [DISPLAY_TYPES.TABLE]: ListerTable,
};
